export default __webpack_public_path__ + "static/media/cheque.efc7d2cd.svg";